module.exports = __webpack_public_path__ + "static/robotMain_01-d8ed66b12569e9b11dfdcf9b0f01cac8.png";